<div class="train-card-wrapper wrap" *ngIf="nextSession && currentSessionIndex !== undefined"
     (click)="detailsOnMobile()">
  <div class="row grow-mobile">
    <div class="column grow-mobile gap meta-data-part">
      <div class="column">
        <p><strong>{{ formatDate(nextSession.date) }}</strong></p>
        <p >{{ formatTime(nextSession.date) }}</p>
      </div>

      <span >{{ 'trains.duration' | translate:{ minutes: train.sessionDuration / (60 * 1E3) } }}</span>
      <p class="text-bold text-primary" >{{ getTrainTimeDelta(train) }}</p>
      <p class="color-danger">{{alertMessage}}</p>
    </div>
    <div class="image-slot">
      <app-image [width]="200" [height]="150" [src]="train.dynamic.thematic.imageUrl" />
    </div>
  </div>
  <div class="column title-part grow center-children-horizontally">
    <div class="cooper text-large text-black tiny-margin-bottom">{{ train.dynamic.thematic.title | thematicField: train.dynamic.thematic.slug:'title' }}</div>
    <div class="mobile-column tiny-margin-bottom " >

      <div class="row gap center-children-vertically width-300 train-card-border pointer" (click)="train.sherpa ? goToSherpa(train.sherpa): {}">
        <app-profile-icon *ngIf="train.sherpa" [profile]="train.sherpa" [tiny]="true" [editable]="false"></app-profile-icon>
        <div class="column no-gap">
          <span>{{ train.dynamic.dynamicType | translate }}</span>
          <span *ngIf="train.sherpa">{{ 'trains.with' | translate }} <u>{{train.sherpa.fullName}}</u></span>
        </div>
      </div>
      <div class="row gap center-children-vertically train-card-border">
        <div class="user-bubble center-children"><app-icon type="users"/></div>
        <span>{{ 'trains.members' | translate:{ count: train.memberShips.length } }}</span>
      </div>

    </div>
    <div class="row gap center-children-vertically tiny-margin-top">
      <p>{{ 'trains.progress' | translate }}</p>
      <div class="steps row">
        <div *ngFor="let session of train.sessions; let index = index;" class="step"
             [class.validated]="index < currentSessionIndex" [class.current]="index === currentSessionIndex"></div>
      </div>
    </div>
  </div>
  <div class="button-part mobile-row center tiny-gap">
    <app-button *ngIf="train.sherpa || !isSherpa" [primary]="true" title="Accès séance" icon="play"
                (click)="joinMeeting()">{{ 'trains.joinSession' | translate }}
    </app-button>
    <app-button [disabled]="apiCalling" title="J'accompagne ce groupe" (click)="clickOnManage()"
                *ngIf="!train.sherpa && isSherpa">{{ 'trains.accompany' | translate }}
    </app-button>
    <app-button title="Détails du parcours" (click)="clickOnDetails()"
                *ngIf="train.sherpa || !isSherpa" [outline]="true">{{ 'trains.details' | translate }}
    </app-button>
  </div>
</div>
<div class="train-card-wrapper mobile-column" *ngIf="!nextSession">
  <div class="row grow gap margin-bottom-mobile">
    <div class="image-slot">
      <app-image [width]="200" [height]="150" [src]="train.dynamic.thematic.imageUrl" [alt]="train.dynamic.thematic.slug" />
    </div>
    <div class="column gap grow center-children-horizontally title-part">
      <div class="cooper text-large text-black">{{ train.dynamic.thematic.title | thematicField: train.dynamic.thematic.slug:'title' }}</div>
      <div class="row mobile-hidden">
        <span><strong>{{ train.dynamic.dynamicType | translate }}</strong> {{ 'trains.with' | translate }} <u>{{ train.sherpa ? train.sherpa.fullName : '' }}</u></span>
      </div>
      <div class="mobile-hidden">{{ 'trains.completedBetween' | translate:{ from: train.getFirstSession().date.toLocaleDateString(), to: train.getLastSession().date.toLocaleDateString() } }}</div>
      <div class="mobile-hidden text-primary">n° {{train.referenceCode}}</div>
    </div>
  </div>
  <div class="desktop-hidden column tiny-gap">
    <div class="row" *ngIf="train.sherpa">
      <span><strong>{{ train.dynamic.dynamicType | translate }}</strong> {{ 'trains.with' | translate }} <u>{{train.sherpa.fullName}}</u></span>
    </div>
    <div>{{ 'trains.completedBetween' | translate:{ from: train.getFirstSession().date.toLocaleDateString(), to: train.getLastSession().date.toLocaleDateString() } }}</div>
    <div class="text-primary">n° {{train.referenceCode}}</div>
  </div>
  <div class="button-part mobile-row center tiny-gap">

    <app-button *ngIf="needToEvaluate || needToEvaluateSixMonths" title="Evaluer" (click)="evaluateTrain()">
      {{ (needToEvaluateSixMonths ? 'trains.doSixMonthReview' : 'trains.doReview') | translate }}
    </app-button>
    <div class="row gap center-children-vertically" *ngIf="evaluationDate">
      <app-icon type="check-dot" />
      {{ 'trains.reviewDoneOn' | translate:{ date: evaluationDate } }}
    </div>
    <div class="row gap center-children-vertically" *ngIf="sixMonthsEvaluationDate">
      <app-icon type="check-dot" />
      {{ 'trains.sixMonthReviewDoneOn' | translate:{ date: sixMonthsEvaluationDate } }}
    </div>
    <app-button title="Détails du parcours" (click)="clickOnDetails()"
                [outline]="true">{{ 'trains.details' | translate }}
    </app-button>

  </div>
</div>

